<template>
  <a-modal
    :title="$t('views.toolMagazine.import.title')"
    :visible="open"
    :confirm-loading="uploading"
    @cancel="importExcelHandleCancel"
    @ok="importExcelHandleChange"
  >
    <a-spin :spinning="uploading" :tip="$t('views.toolMagazine.import.uploading')">
      <a-upload-dragger
        name="file"
        accept=".xlsx, .xls"
        :file-list="fileList"
        :multiple="false"
        :remove="handleRemove"
        :before-upload="beforeUpload"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">{{ $t('views.toolMagazine.import.dragHint') }}</p>
        <p class="ant-upload-hint">{{ $t('views.toolMagazine.import.clickHint') }}</p>
      </a-upload-dragger>
      <div class="tool-magazine-import-template">
        <a @click="importTemplate">{{ $t('views.toolMagazine.import.downloadTemplate') }}</a>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import { importToolMagazineData } from '@/api/user/toolMagazine'

export default {
  name: 'ToolMagazineImportExcel',
  data () {
    return {
      open: false,
      fileList: [],
      uploading: false
    }
  },
  methods: {
    importExcelHandleCancel () {
      this.open = false
      this.fileList = []
      this.uploading = false
    },
    importTemplate () {
      this.download(
        'user/tool-magazine/importTemplate',
        {},
        `tool_magazine_template_${new Date().getTime()}.xlsx`
      )
    },
    importExcelHandleOpen () {
      this.open = true
      this.fileList = []
    },
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
    importExcelHandleChange () {
      if (!this.fileList.length) {
        this.$message.warning(this.$t('views.toolMagazine.import.fileRequired'))
        return
      }
      this.uploading = true
      const formData = new FormData()
      formData.append('file', this.fileList[0])
      importToolMagazineData(formData)
        .then(response => {
          const ok = response && (response.success === true || response.code === 1 || response.code === 20001)
          if (ok) {
            this.fileList = []
            this.$message.success(response.message || response.msg || this.$t('views.toolMagazine.import.ok'))
            this.open = false
            this.$emit('ok')
          } else {
            this.$message.error(response.message || response.msg || this.$t('views.toolMagazine.import.fail'))
          }
        })
        .finally(() => {
          this.uploading = false
        })
    },
    handleRemove () {
      this.fileList = []
      this.uploading = false
    }
  }
}
</script>

<style scoped>
.tool-magazine-import-template {
  margin-top: 12px;
}
</style>
